import { Badge, BadgeProps } from '@mantine/core';
import { ROLE_LABELS, type ExporterStatus, type Role, type UserStatus } from '@mexp/shared';

const ROLE_COLORS: Partial<Record<Role, string>> = {
  super_admin: 'grape',
  admin: 'violet',
  mis: 'indigo',
  bd: 'orange',
  ra: 'cyan',
  exporter: 'pink',
};

export function RoleBadge({ role, ...props }: { role: Role } & BadgeProps) {
  return (
    <Badge color={ROLE_COLORS[role] ?? 'teal'} {...props}>
      {ROLE_LABELS[role]}
    </Badge>
  );
}

const STATUS_COLORS: Record<string, string> = {
  active: 'green',
  inactive: 'gray',
  suspended: 'red',
  pending_invite: 'yellow',
};

const STATUS_LABELS: Record<string, string> = {
  active: 'Active',
  inactive: 'Inactive',
  suspended: 'Suspended',
  pending_invite: 'Invited',
};

export function AccountStatusBadge({ status, ...props }: { status: UserStatus | ExporterStatus } & BadgeProps) {
  return (
    <Badge color={STATUS_COLORS[status] ?? 'gray'} variant="dot" {...props}>
      {STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
